import { useState } from 'react';
import { useSelector } from 'react-redux';
import useOnMount from '../../hooks/useOnMount';
import { selectIsDiscord } from '../../selectors/app';
import { ROOT_PATH } from '../../constants/paths';

export function useDiscord(history) {
  const isDiscord = useSelector(selectIsDiscord);
  const [isDiscordReady, setIsDiscordReady] = useState(false);
  const [discordError, setDiscordError] = useState();
  const isRootPath = history.location.pathname === ROOT_PATH;

  useOnMount(() => {
    if (!isDiscord) {
      return;
    }

    let teardown;

    async function loadDiscordManager() {
      const { discordManager } = await import('./discordManager');

      teardown = discordManager.destroy;

      discordManager.on('ready', () => setIsDiscordReady(true));

      try {
        await discordManager.init();
      } catch (e) {
        setDiscordError(e);
      }
    }

    loadDiscordManager();

    return teardown;
  });

  return {
    isDiscordReady,
    showDiscordSplashScreen:
      isDiscord && (isRootPath || !isDiscordReady || discordError),
    discordError,
  };
}
